import {
  getPendingSales,
  markSaleSynced,
  deleteSyncedSales,
  cacheInventory,
  cacheCustomers,
  cacheDashboard,
} from './db';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';

export const syncPendingSales = async (token) => {
  const pending = await getPendingSales();
  if (pending.length === 0) return { synced: 0, failed: 0 };

  let synced = 0;
  let failed = 0;

  for (const sale of pending) {
    try {
      const { localId, queuedAt, synced: _synced, ...saleData } = sale;

      const res = await fetch(`${API_URL}/sales`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(saleData),
      });

      if (res.ok) {
        await markSaleSynced(localId);
        synced++;
      } else {
        failed++;
      }
    } catch {
      failed++;
    }
  }

  if (synced > 0) {
    await deleteSyncedSales();
  }

  return { synced, failed };
};

export const refreshCache = async (token) => {
  try {
    const headers = { Authorization: `Bearer ${token}` };

    const [inventoryRes, customersRes, dashboardRes] = await Promise.all([
      fetch(`${API_URL}/inventory`, { headers }),
      fetch(`${API_URL}/customers`, { headers }),
      fetch(`${API_URL}/finances/summary?period=year`, { headers }),
    ]);

    if (inventoryRes.ok) {
      const inventory = await inventoryRes.json();
      await cacheInventory(Array.isArray(inventory) ? inventory : inventory.items || []);
    }
    if (customersRes.ok) {
      const customers = await customersRes.json();
      await cacheCustomers(Array.isArray(customers) ? customers : customers.items || []);
    }
    if (dashboardRes.ok) {
      const dashboard = await dashboardRes.json();
      await cacheDashboard(dashboard);
    }
  } catch (err) {
    console.log('[syncService] Cache refresh failed (offline?):', err.message);
  }
};
